import React, { useState, useEffect } from 'react';
import { showCreateOUModal } from '../../../../actions/modal';
import { forceValidation } from 'businessLogic/validation.js';
import { orgNameDuplicate, createOUByAdmin, getOrgUnitWithSearchTerm, updateRHSTotalCount } from 'actions/organisation';
import { useDispatch } from 'react-redux';
import Info from '../../info';

const RightPanel = (props) => {
  const [creatingOrgUnit, setCreatingOrgUnit] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.messageData && props.messageData.text) {
      if (props.messageData.text.toString().indexOf(APP.LANGUAGE.CreateOU.OrgNameDuplicateBadMessage) != -1) {
        const orgNameInput = document.querySelectorAll('input[name="orgName"]');
        if (orgNameInput.length > 0) {
          orgNameInput[0].focus();
        }
      } else if (props.messageData.text.toString().indexOf(APP.LANGUAGE.CreateOU.OrgAbbrevDuplicateBadMessage) != -1) {
        const orgAbbrevInput = document.querySelectorAll('input[name="orgAbbrev"]');
        if (orgAbbrevInput.length > 0) {
          orgAbbrevInput[0].focus();
        }
      }
    }
  }, []);

  const saveCreateOU = () => {
    setCreatingOrgUnit(true);
    let payload = props.getPayload();
    let cb = (successful, createdOU, name = payload.name) => {
      setCreatingOrgUnit(false);
      if (!!successful) {
        if (createdOU && createdOU.networkId) {
          props.searchInEntityPageByName(payload.name, () => {
            closeModal();
            dispatch(updateRHSTotalCount('org', 1));
          });
          //dispatch(getOrgUnitWithSearchTerm(createdOU.networkId, () => closeModal()));
        } else {
          closeModal();
        }
      }
    };
    dispatch(createOUByAdmin(payload, cb));
  };

  const saveModalChange = (event) => {
    let areThereErrors = forceValidation(undefined, undefined, 'createOrgUnitForm');
    if (!areThereErrors && !event.target.className.includes('disable') && !creatingOrgUnit) {
      saveCreateOU();
    }
  };

  const closeModal = () => {
    dispatch(showCreateOUModal(false));
  };

  const saveClasses =
    'ui disable labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';

  return (
    <div>
      <div className="mrts mrbl max-width">
        <button
          tabIndex="3"
          type="button"
          name="saveBtn"
          data-group="createOrgUnitForm"
          onClick={(event) => saveModalChange(event)}
          className={creatingOrgUnit ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark icon" />
        </button>
        <button
          tabIndex="4"
          type="button"
          onClick={closeModal}
          className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <div className="mrtl">
        <Info
          paragraphs={[
            APP.LANGUAGE.CreateOU.InfoText1,
            APP.LANGUAGE.CreateOU.InfoText2,
            APP.LANGUAGE.CreateOU.InfoText3,
          ]}
        />
      </div>
    </div>
  );
};

export default RightPanel;
